//
//

/**
 * 此页面用于跳转各类型合同审批详情页面
 */
import {selectContractById} from "@/api/contract/contract";
export default {
    name: "approveCont",
  created(){
      //设置流程参数传递到详细页面
    var taskParam=this.$route.query;
    var data={contractId:taskParam.businessKey};
    selectContractById(data).then(response => {
      if(response){
        if(response.contTypeCode=='software_sale'||response.contTypeCode=='technical_service'){
          this.$router.push({ path:'/contract/technicalSoftwareDetail',query:{cid:response.id,taskParam}});
        }
        if(response.contTypeCode=='human_day_service'){
          this.$router.push({ path:'/contract/humanDayServiceDetail',query:{cid:response.id,taskParam}});
        }
        if(response.contTypeCode=='human_day_total'){
          this.$router.push({ path:'/contract/humanDayTotalDetail',query:{cid:response.id,taskParam}});
        }
        if(response.contTypeCode=='purchase_contract'){
          this.$router.push({ path:'/contract/purchaseDetail',query:{cid:response.id,taskParam}});
        }
        if(response.contTypeCode=='ctrip_businessTravel'){
          this.$router.push({ path:'/contract/ctripDetail',query:{cid:response.id,taskParam}});
        }
        if(response.contTypeCode=='humanDay_outsourcing'){
          this.$router.push({ path:'/contract/humanDayoutDetail',query:{cid:response.id,taskParam}});
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/view/contract/approveCont.vue